
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

import { VideoCameraTwoTone, FileMarkdownTwoTone, EditTwoTone } from "@ant-design/icons-vue";

const awards = [
    {
        date: "2022.08",
        html: "Guest talk @SMU: What rejects your paper submission? Towards more rigorous research on VA systems.",
        type: "talk",
    },
    {
        date: "2022.07",
        html: "<a class='url' href='https://ebookshelf.ust.hk/flippingbook/G22789/#p=23'>Data is Life</a>, feature story in the 2022 summer release of the biannual <a class='url' href='https://alum.hkust.edu.hk/alumni-stories/alumni-news-magazine'>HKUST Almuni</a> magazine.",
        type: "press",
    },
    {
        date: "2022.05",
        html: "HKUST GSAA (Graduate Students and Alumni Association): <a href='https://mp.weixin.qq.com/s/KAo_tMcFLTs-k9ewOWIdbg' class='url'>计算机博士生伍翱宇：港科大本硕博九年的精彩历程</a>.",
        type: "press",
    },
    {
        date: "2022.04",
        html: "Guest talks @<a href='https://games-cn.org/games-webinar-20220428-227/' class='url'>GAMES (Graphics And Mixed Environment Symposium) Webinar</a>: 如何高效调研文献 (A beginner's guide to literature surveys, in Chinese). <a href='https://www.bilibili.com/video/BV1Va411e7FK?spm_id_from=333.851.header_right.fav_list.click' class='url'>Recording on Bilibili</a>.",
        type: "talk",
    },
    {
        date: "2021.11",
        html: "<a href='https://seng.hkust.edu.hk/news/20211116/phd-student-wu-aoyu-received-microsoft-research-asia-fellowship' class='url'>PhD Student WU Aoyu Received Microsoft Research Asia Fellowship</a>, by School of Engineering, HKUST.",
        type: "press",
    },
    {
        date: "2021.08",
        html: "Guest talks @<a href='http://games-cn.org/games-webinar-20210715-191/' class='url'>GAMES (Graphics And Mixed Environment Symposium) Webinar</a>: Learning to Automate Chart Configurations.",
        type: "talk",
    },
    {
        date: "2021.07",
        html: '可视化研究，不仅仅只有图表 (Visualization research is more than graphs, in Chinese). <a href="https://mp.weixin.qq.com/s/nrhgbhdjTPp_COu6RTJF4A" class="url">Link</a>.',
        type: "blogging",
    },
    {
        date: "2021.07",
        html: "Guest talks @Tongji/Fudan/Shandong Univeresity: Empower data visualizations with AI - from data visualization to visualization data.",
        type: "talk",
    },
    {
        date: "2019.04",
        html: '大公報: <a href="http://www.takungpao.com.hk/231106/2019/0430/281981.html" class="url">智在校園 大數據助力</a>.',
        type: "press",
    },
    {
        date: "2019.03",
        html: 'South China Morning Post: <a href="https://www.scmp.com/news/hong-kong/education/article/3003997/making-long-queues-thing-past-goal-two-computing-science" class="url">Making long queues a thing of the past is the goal for two computing science master’s students at Hong Kong University of Science and Technology</a>.',
        type: "press",
    },
    {
        date: "2018.12",
        html: 'HKUST: <a href="https://www.seng.ust.hk/web/publication/infocus/no30/mobile/index.html#p=24/" class="url">Feature story on the School of Engineering yearbook</a>.',
        type: "press",
    },
];

export default defineComponent({
    name: "App",
    components: {
        VideoCameraTwoTone,
        FileMarkdownTwoTone,
        EditTwoTone,
    },
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        return {
            ...toRefs(state),
            awards,
        };
    },
    computed: {},
});
